<template>
    <div class="showcase block block-border-bottom-grey">
      <div class="container">
        <h2 class="block-title">
          Capability Showcase
        </h2>
        <!-- <p>This is Photoshop's version of Lorem Ipsum. Proin gravida nibh vel velit auctor aliquet. Aenean sollicitudin, lorem
          quis bibendum auctor, nisi elit consequat ipsum, nec sagittis sem nibh id elit. Duis sed odio sit amet nibh vulputate
          cursus a sit amet mauris.</p> -->
        <div class="owl-carousel owl-theme">
          <div class="item">
            <router-link :to="{ name: 'Compression'}" class="overlay-wrapper">
              <img src="../assets/img/showcase/compression-spring-1.png" alt="Compression Springs image" class="img-responsive underlay">
            </router-link>
            <div class="item-details bg-noise">
              <h4 class="item-title">
                <router-link :to="{ name: 'Compression'}">Compression Springs</router-link>
              </h4>
              <router-link :to="{ name: 'Compression'}" class="btn btn-more">
                <i class="fa fa-plus"></i>Read more</router-link>
            </div>
          </div>
          <div class="item">
            <router-link :to="{ name: 'Extension'}"  class="overlay-wrapper">
              <img src="../assets/img/showcase/extension-spring.png" alt="Extension Springs image" class="img-responsive underlay">
            </router-link>
            <div class="item-details bg-noise">
              <h4 class="item-title">
                <router-link :to="{ name: 'Extension'}">Extension Springs</router-link>
              </h4>
              <router-link :to="{ name: 'Extension'}" class="btn btn-more">
                <i class="fa fa-plus"></i>Read more</router-link>
            </div>
          </div>
          <div class="item">
            <router-link :to="{ name: 'Torsion'}"  class="overlay-wrapper">
              <img src="../assets/img/showcase/torsion-spring.png" alt="Torsion Springs image" class="img-responsive underlay">
            </router-link>
            <div class="item-details bg-noise">
              <h4 class="item-title">
                <router-link :to="{ name: 'Torsion'}" >Torsion Springs</router-link>
              </h4>
              <router-link :to="{ name: 'Torsion'}" class="btn btn-more">
                <i class="fa fa-plus"></i>Read more</router-link>
            </div>
          </div>
          <div class="item">
            <router-link :to="{ name: 'HarrowTineSprings'}" class="overlay-wrapper">
              <img src="../assets/img/showcase/harrow-tine.png" alt="Harrow Tines image" class="img-responsive underlay">
            </router-link>
            <div class="item-details bg-noise">
              <h4 class="item-title">
                <router-link :to="{ name: 'HarrowTineSprings'}">Harrow Tine Springs</router-link>
              </h4>
              <router-link :to="{ name: 'HarrowTineSprings'}" class="btn btn-more">
                <i class="fa fa-plus"></i>Read more</router-link>
            </div>
          </div>
          <div class="item">
            <router-link :to="{ name: 'GarageDoorSpringsTorsion'}" class="overlay-wrapper">
              <img src="../assets/img/showcase/garage-door-torsion-spring.png" alt="Garage Door Torsion Springs image" class="img-responsive underlay">
            </router-link>
            <div class="item-details bg-noise">
              <h4 class="item-title">
                <router-link :to="{ name: 'GarageDoorSpringsTorsion'}">Garage Door Torsion Springs</router-link>
              </h4>
              <router-link :to="{ name: 'GarageDoorSpringsTorsion'}" class="btn btn-more">
                <i class="fa fa-plus"></i>Read more</router-link>
            </div>
          </div>
          <div class="item">
            <router-link :to="{ name: 'GarageDoorSpringsExtension'}" class="overlay-wrapper">
              <img src="../assets/img/showcase/garage-door-extension-spring.png" alt="Garage Door Extension Springs image" class="img-responsive underlay">
            </router-link>
            <div class="item-details bg-noise">
              <h4 class="item-title">
                <router-link :to="{ name: 'GarageDoorSpringsExtension'}">Garage Door Extension Springs</router-link>
              </h4>
              <router-link :to="{ name: 'GarageDoorSpringsExtension'}" class="btn btn-more">
                <i class="fa fa-plus"></i>Read more</router-link>
            </div>
          </div>
        </div>
      </div>
    </div>

</template>

<script>
export default {
  name: "HomePageCapabilityShowcase",
  mounted: function () {
  this.$nextTick(function () {
    $('.owl-carousel').owlCarousel({
    loop: true,
    margin: 10,
    items: 4,
    autoplay: true,
    autoplayTimeout: 4000,
    dots: true,
    nav: true,
    responsive: {
      0: {
        items: 1,
      },
      600: {
        items: 3,
      },
    }
  });
  })
}
};
</script>




// WEBPACK FOOTER //
// src/components/HomePageCapabilityShowcase.vue